module.exports = __webpack_public_path__ + "img/valyoo-logo.e9cf743b.svg";